import React from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Divider,
  Chip,
  Box,
  Stack,
  TableContainer,
  useTheme,
} from "@mui/material";

export default function SalaryTable({ data, totals, PKR }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const totalsCell = {
    bgcolor: isDark ? "rgba(86,198,98,0.08)" : "#f8fafc",
  };

  return (
    <Paper
      elevation={0}
      sx={{
        border: `3px solid ${isDark ? "rgba(86,198,98,0.25)" : "#dcfce7"}`,
        background: theme.palette.background.paper,
        overflow:'hidden'
      }}
    >
      {/* make it responsive */}
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ "& th": { bgcolor: "#56C662", color: "white" } }}>
              <TableCell>Employee ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Designation</TableCell>
              <TableCell align="right">Basic Salary</TableCell>
              <TableCell align="right">Allowances</TableCell>
              <TableCell align="right">Deductions</TableCell>
              <TableCell align="right">Advance Paid</TableCell>
              <TableCell align="right">Net Salary</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((e) => (
              <TableRow key={e.id} hover>
                <TableCell>{e.id}</TableCell>
                <TableCell>{e.name}</TableCell>
                <TableCell>{e.role}</TableCell>
                <TableCell align="right">{PKR(e.basic)}</TableCell>
                <TableCell align="right">{PKR(e.allowances)}</TableCell>
                <TableCell align="right">{PKR(e.deductions)}</TableCell>
                <TableCell align="right">{PKR(e.advance)}</TableCell>
                <TableCell align="right">
                  <Typography fontWeight={700} color="primary.main">
                    {PKR(e.net)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor:
                              e.status === "Paid"
                                ? "success.main"
                                : "warning.main",
                          }}
                        />
                        <Typography variant="body2" sx={{ pr:'6px' }} component="span">
                          {e.status}
                        </Typography>
                      </Stack>
                    }
                    sx={{
                      fontWeight: 600,
                      border: "none",
                      bgcolor:
                        e.status === "Paid"
                          ? "rgba(22,163,74,0.08)"
                          : "rgba(245,158,11,0.12)",
                      color:
                        e.status === "Paid"
                          ? "success.main"
                          : "warning.main",
                      pl: 0.5,
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}

            {/* Totals row */}
            <TableRow>
              <TableCell colSpan={3} sx={totalsCell}>
                <Typography fontWeight={600}>
                  Total — {totals.staff} employees
                </Typography>
              </TableCell>
              <TableCell align="right" sx={totalsCell}>
                {PKR(totals.sumBasic)}
              </TableCell>
              <TableCell align="right" sx={totalsCell}>
                {PKR(totals.sumAllow)}
              </TableCell>
              <TableCell align="right" sx={totalsCell}>
                {PKR(totals.sumDed)}
              </TableCell>
              <TableCell align="right" sx={totalsCell}>
                {PKR(totals.sumAdv)}
              </TableCell>
              <TableCell align="right" sx={totalsCell}>
                <Typography fontWeight={800}>
                  {PKR(totals.sumNet)}
                </Typography>
              </TableCell>
              <TableCell sx={totalsCell}>
                <Typography variant="body2" color="text.secondary">
                  {totals.paid} Paid / {totals.unpaid} Unpaid
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography variant="caption" color="text.secondary">
          * Net = Basic + Allowances − Deductions − Advance Paid. All amounts
          are in PKR.
        </Typography>
      </Box>
    </Paper>
  );
}
